import { createStore } from 'redux';
import QuestionReducer from './reducers/QuestionReducer';

export const hookstore = createStore(QuestionReducer);